export class PaymentModuleUtility {
  static removeLastBackslash(str: string | undefined): string {
    if (!str) return "";
    return str.replace(/\/$/, "");
  }

  static isAlphaBetical(str: string): boolean {
    return /^[a-zA-Z]+$/.test(str);
  }
}
